import { jsx as n } from "react/jsx-runtime";
import l from "react";
import { useRouter as d } from "next/router";
import { c as u } from "./clsx.OuTLNxxd.js";
import M from "next/link";
import { Link as L } from "@sitecore-jss/sitecore-jss-nextjs";
const h = l.forwardRef(
  ({ href: c, field: e, className: r, children: s, prefetch: i, ...a }, o) => e ? /* @__PURE__ */ n(
    L,
    {
      prefetch: i ?? !1,
      ref: o,
      field: e,
      className: r,
      ...a,
      children: s
    }
  ) : /* @__PURE__ */ n(
    M,
    {
      prefetch: i ?? !1,
      ref: o,
      href: c || "",
      className: r,
      ...a,
      children: s
    }
  )
);
h.displayName = "UnifiedLink";
const N = l.forwardRef(
  ({ href: c, field: e, className: r, children: s, prefetch: i, ...a }, o) => {
    const { basePath: f } = d();
    if (f.startsWith("/calendar") || f.startsWith("/physicians")) {
      const m = e && "value" in e ? e.value : e, { class: k, ...t } = m || {}, p = m ? { ...t, className: u(r, t.className) } : {
        href: c || "#",
        className: r,
        ...a
      };
      return /* @__PURE__ */ n("a", { ref: o, ...p, children: s || (t == null ? void 0 : t.text) });
    }
    return /* @__PURE__ */ n(
      h,
      {
        prefetch: i,
        ref: o,
        field: e,
        href: c || "",
        className: r,
        ...a,
        children: s
      }
    );
  }
);
N.displayName = "MhoModuleLink";
export {
  N as M
};
